import moment from 'moment';
import ForecastReport from './credit-forecast-report';
import CountsReport from './credit-counts-report';
import UsageReport from './credit-usage-report';
import debounce from 'debounce';
import LedgerReport from './credit-ledger-report';

export default class CreditReport {
  constructor() {
    this.forecast = new ForecastReport();
    this.counts = new CountsReport();
    this.usage = new UsageReport();
    this.ledger = new LedgerReport();

    this.from = null;
    this.through = null;
    this.customCampusTags = [];

    this.schoolId = 0;

    this.fetchAll = debounce(this.fetchAll.bind(this), 250);
    this.fetchBin = debounce(this.fetchBin.bind(this), 250);
  }

  get loading() {
    return this.forecast.loading
      || this.counts.loading
      || this.usage.loading
      || this.ledger.loading;
  }

  initialize($http, schoolId) {
    this.forecast.initialize($http, schoolId);
    this.counts.initialize($http, schoolId);
    this.usage.initialize($http, schoolId);
    this.ledger.initialize($http, schoolId);
    this.schoolId = schoolId;

    this.byBin('month');

    return this;
  }

  between(from, through) {
    this.from = from ? moment(from) : null;
    this.through = through ? moment(through) : null;

    this.usage.between(from, through);
    this.counts.between(from, through);
    this.ledger.between(from, through);

    return this;
  }
  byBin(bin) {
    this.usage.byBin(bin);

    return this;
  }

  withCustomTags(tags) {
      this.customCampusTags = tags;
      this.counts.withCustomTags(tags);
      this.usage.withCustomTags(tags);
      this.ledger.withCustomTags(tags);

      return this;
  }

  fetchAll() {
    return Promise.all([
      this.forecast.fetch(),
      this.counts.fetch(),
      this.usage.fetch(),
      this.ledger.fetch(),
    ]);
  }
  fetchBin() {
    return this.usage.fetch();
  }
}